import { log } from 'util';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MatSnackBar, MAT_DIALOG_DATA } from '@angular/material';
import { Validators, FormControl } from '@angular/forms';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { HttpService } from '../../../services/http/http.service';

@Component({
  selector: 'app-test-format',
  templateUrl: './test-format.component.html',
  styleUrls: ['./test-format.component.scss']
})
export class TestFormatComponent implements OnInit {
  difficultyArr = ['Easy', 'Medium', 'Hard'];
  questionDifficultyArr = ['Easy', 'Medium', 'Hard', 'Very Hard'];
  timeDurationArr = ['Time1', 'Time2', 'Time3'];
  pointsArr = ['1', '2', '3', '4'];
  alphabetExp = '[a-zA-Z ]*$';
  valueCountError: boolean = false;
  testName = new FormControl('', [Validators.required, Validators.pattern(this.alphabetExp),
  Validators.maxLength(30), this.noWhitespaceValidator]);
  timeDuration = new FormControl('', [Validators.required]);
  timeDuration1: any;
  testType = new FormControl('');
  easyTopic = new FormControl('');
  mediumTopic = new FormControl('');
  hardTopic = new FormControl('');
  topicDifficulty = new FormControl('');
  topicDifficultyArray = [];
  topicDifficultyArrayInteger = [];
  data = [];
  countError: boolean = false;
  countError1: boolean = false;
  percentageOfNo;
  countError2: boolean = false;
  easyPercentage; mediumPercentage; hardPercentage; veryhardPercentage
  countError3: boolean = false;
  questionDifficulty = new FormControl('', [Validators.required]);
  noOfProgramQues = new FormControl('', [Validators.required, Validators.pattern('^[0-9]*')]);
  easy = new FormControl('', [Validators.required, Validators.min(0), Validators.max(100)]);
  medium = new FormControl('', [Validators.required, Validators.min(0), Validators.max(100)]);
  hard = new FormControl('', [Validators.required, Validators.min(0), Validators.max(100)]);
  veryhard = new FormControl('', [Validators.required, Validators.min(0), Validators.max(100)]);
  testTypeSelected: any;
  activeTestTimeList: any[];
  testTimeList: any;
  timeDurationId: any;
  testSet: any;
  constructor(
    public dialogRef: MatDialogRef<TestFormatComponent>, public snackBar: MatSnackBar,
    private spinnerService: Ng4LoadingSpinnerService,
    private httpService: HttpService,
    @Inject(MAT_DIALOG_DATA) data: any) {
    this.data = data;
  }

  ngOnInit() {

    // this.testSet = localStorage.getItem('testSetInTestFormat');
    this.testSet = 0;
    console.log("testformat data", this.data);
    if (this.testTypeSelected != undefined) {
      this.autoFillQuestionDifficulty(this.testTypeSelected);
    }
    this.getTestTime();
  }

  getTestTime() {
    this.activeTestTimeList = [];
    this.spinnerService.show();
    // tslint:disable-next-line:prefer-const
    let contentBody = { url: '/testtimes' };
    this.httpService.httpGet(contentBody).subscribe(response => {
      console.log("getTestTime",response);
      this.testTimeList = response.data;
      for (let i = 0; i < this.testTimeList.length; i++) {
        if (this.testTimeList[i].status === 'ACTIVE') {
          this.activeTestTimeList.push(this.testTimeList[i]);
        }
      }
      // console.log("activeTestTimeList", this.activeTestTimeList);
      this.spinnerService.hide();

    }, error => {
      console.log('error ', error);
      this.spinnerService.hide();
      this.openSnackBar(error.error.message);
    });
  }

  closeDialog(flag: boolean): void {
    this.dialogRef.close(flag);
  }
  noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }

  getTestNameErrorMessage() {
    return this.testName.hasError('required') ? 'Test Name is required' :
      this.testName.hasError('pattern') ? 'Please provide valid test name' :
        this.testName.hasError('maxlength') ? 'Test name length should not be greater than 30' :
          this.testName.hasError('whitespace') ? 'Please provide valid test name' :
            '';
  }

  getNoOfProgramQuesMessage() {
    return this.noOfProgramQues.hasError('required') ? 'Percentage of programming questions is required' :
      this.noOfProgramQues.hasError('pattern') ? 'Percentage of programming questions can only be numerical' :
        '';
  }
  getErrorForEasy() {
    return this.easy.hasError('required') ? 'This field is required' :
      this.easy.hasError('min') ? 'Value shouldn\'t be less than 0%' :
        this.easy.hasError('max') ? 'Value shouldn\'t be greater than 100%' :
          this.easy.hasError('pattern') ? 'This field can\'t contains alphabets' : '';
  }
  getErrorForMedium() {
    return this.medium.hasError('required') ? 'This field is required' :
      this.medium.hasError('min') ? 'Value shouldn\'t be less than 0%' :
        this.medium.hasError('max') ? 'Value shouldn\'t be greater than 100%' :
          this.medium.hasError('pattern') ? 'This field can\'t contains alphabets' : '';
  }
  getErrorForHard() {
    return this.hard.hasError('required') ? 'This field is required' :
      this.hard.hasError('min') ? 'Value shouldn\'t be less than 0%' :
        this.hard.hasError('max') ? 'Value shouldn\'t be greater than 100%' :
          this.hard.hasError('pattern') ? 'This field can\'t contains alphabets' : '';
  }
  getErrorForVeryHard() {
    return this.veryhard.hasError('required') ? 'This field is required' :
      this.veryhard.hasError('min') ? 'Value shouldn\'t be less than 0%' :
        this.veryhard.hasError('max') ? 'Value shouldn\'t be greater than 100%' :
          this.veryhard.hasError('pattern') ? 'This field can\'t contains alphabets' : '';
  }

  getErrorMessageOfTestDuration(){
    return this.timeDuration.hasError('required') ? 'This field is required' : ''; 
  }


  onCheckboxChagen(event, value) {
    var value1;
    if (event.checked) {
      if (value == 'Easy') {
        value1 = 1;
      }
      if (value == 'Medium') {
        value1 = 2;
      }
      if (value == 'Hard') {
        value1 = 3;
      }
      this.topicDifficultyArray.push(value);
      this.topicDifficultyArrayInteger.push(value1);
    }
    if (!event.checked) {
      console.log("!!!Checked");
      let index = this.topicDifficultyArray.indexOf(value);
      this.topicDifficultyArray.splice(index, 1);
      let index1 = this.topicDifficultyArrayInteger.indexOf(value1);
      this.topicDifficultyArrayInteger.splice(index1, 1);
    }
    console.log("topicDifficultyArray", this.topicDifficultyArray);
  }

  addTestFormat() {
    // var numberOfQuestion = this.easyPercentage + this.mediumPercentage + this.hardPercentage + this.veryhardPercentage;
    // this.percentageOfNo = (numberOfQuestion * this.noOfProgramQues.value) / 100;

    // console.log("this.percentageOfNo", this.percentageOfNo);
    console.log("Id",this.timeDuration.value.id);
    // console.log("timeDuration1",timeDuration1.id);
    
    console.log("this.hard.value",this.hard.value);
    

    if (this.noOfProgramQues.value > 0 && this.noOfProgramQues.value <= 100 && this.easy.value >= 0 &&
      this.medium.value >= 0 && this.hard.value >= 0 && this.veryhard.value >= 0) {
      const data = {
        name: this.testName.value,
        noOfProgrammingQuestion: this.noOfProgramQues.value,
        testDifficulty: this.testType.value,
        topicDifficulty: this.topicDifficultyArrayInteger,
        complexityFourCount: this.veryhard.value,
        complexityOneCount: this.easy.value,
        complexityThreeCount: this.hard.value,
        complexityTwoCount: this.medium.value,
        testTimeId: this.timeDuration.value.id
        // testTimeId: this.data["testTime"][0].id
      }
      console.log("questionsetformats", data);
      var flag = this.checkTopicDifficultyAvailability();
      console.log(flag);

      if (flag) {
        this.spinnerService.show();
        const contentBody = { url: '/questionsetformats', body: data };
        this.httpService.httpPost(contentBody, true).subscribe(response => {
          console.log('success ', response);
          this.timeDurationId = response.data.testTimeId;
          console.log('Time duration id ', this.timeDurationId);
          this.openSnackBar(response['message']);
          this.closeDialog(true);

          this.spinnerService.hide();
        }, error => {
          console.log('error ', error);
          this.spinnerService.hide();
          this.openSnackBar(error.error.message);
        });
      }
      else {
        this.openSnackBar("Atleast one topic should be there")
      }
    }
    else {
      this.openSnackBar("Provide valid data");

    }
  }
  openSnackBar(message: string) {
    this.snackBar.open(message, null, {
      duration: 2000,
    });
  }
  checkTopicDifficultyAvailability() {
    var returnValue = true;
    for (let i = 0; i < this.topicDifficultyArray.length; i++) {
      switch (this.topicDifficultyArray[i]) {
        case 'Easy':
          returnValue = returnValue && this.data["easyTopicList"].length > 0;
          break;
        case 'Medium':
          returnValue = returnValue && this.data["mediumTopicList"].length > 0;
          break;
        case 'Hard':
          returnValue = returnValue && this.data["hardTopicList"].length > 0;
      }
    }
    return returnValue;
  }
  getElementByDifficultyName(name) {
    console.log("--> ", name);
    console.log("this. data ", this.data["questionDifficulty"]);
    return this.data["questionDifficulty"].find(x => x.difficultyName == name)
  }

  // setValueForInput() {
  //   if (this.easy.value > 0 && this.easy.value <= 100) {
  //     this.easy.setValue(0);
  //   }
  //   if (this.medium.value > 0 && this.medium.value <= 100) {
  //     this.medium.setValue(0);
  //   }
  //   if (this.hard.value > 0 && this.hard.value <= 100) {
  //     this.hard.setValue(0);
  //   }
  //   if (this.veryhard.value > 0 && this.veryhard.value <= 100) {
  //     this.veryhard.setValue(0);
  //   }

  // }
  autoFillQuestionDifficulty(value) {
  console.log("value : ", value)
    if (value == 'Easy') {
      let value1 = parseInt(this.medium.value) + parseInt(this.hard.value) + parseInt(this.veryhard.value);
      if (!isNaN(value1)) {
        var val = 100 - value1;
        this.easy.setValue(val);
        if (val < this.data["testTime"][0].minPercentage) {
          this.countError = true;
        }
        else {
          this.countError = false;
        }
        if (this.easy.value < 0 || this.easy.value > 100) {
          this.easy.setValue(0);
        }
      }
    }
    else if (value == 'Medium') {
      let value1 = parseInt(this.easy.value) + parseInt(this.hard.value) + parseInt(this.veryhard.value);
      if (!isNaN(value1)) {
        var val = 100 - value1;
        this.medium.setValue(val);
        if (val < this.data["testTime"][0].minPercentage) {
          this.countError1 = true;
        }
        else {
          this.countError1 = false;
        }
        if (this.medium.value < 0 || this.medium.value > 100) {
          this.medium.setValue(0);
        }
      }
    }
    else if (value == 'Hard') {
      let value1 = parseInt(this.easy.value) + parseInt(this.medium.value) + parseInt(this.veryhard.value);
      if (!isNaN(value1)) {
        var val = 100 - value1;
        this.hard.setValue(val);
        // if (val < this.data["testTime"][0].minPercentage) {
        if(val < this.testSet.minPercentage) {
          this.countError2 = true;
        }
        else {
          this.countError2 = false;
        }
        if (this.hard.value < 0 || this.hard.value > 100) {
          this.hard.setValue(0);
        }
      }
    }
    else {
      let value1 = parseInt(this.medium.value) + parseInt(this.hard.value) + parseInt(this.easy.value);
      if (!isNaN(value1)) {
        var val = 100 - value1;
        this.veryhard.setValue(val);
        if (val < this.data["testTime"][0].minPercentage) {
          this.countError3 = true;
        }
        else {
          this.countError3 = false;
        }
        if (this.veryhard.value < 0 || this.veryhard.value > 100) {
          this.veryhard.setValue(0);
        }
      }
    }

    if (this.easy.value != null) {
      console.log('--> ',  this.getElementByDifficultyName('Easy').time);
      console.log('this.testSet --->', this.testSet);
      this.easyPercentage = Math.floor((this.testSet * 60 / 100) * parseInt(this.easy.value) /
        this.getElementByDifficultyName('Easy').time);
    }
    else {
      this.easyPercentage = 0;
    }
    if (this.medium.value != null) {
      console.log('--> ',  this.getElementByDifficultyName('Easy').time);
      this.mediumPercentage = Math.floor((this.testSet * 60 / 100) * parseInt(this.medium.value) /
        this.getElementByDifficultyName('Medium').time);
    }
    else {
      this.mediumPercentage = 0;
    }
    if (this.hard.value != null) {
      this.hardPercentage = Math.floor((this.testSet * 60 / 100) * parseInt(this.hard.value) /
        this.getElementByDifficultyName('Hard').time);
    } else {
      this.hardPercentage = 0;
    }
    if (this.veryhard.value != null) {
      this.veryhardPercentage = Math.floor((this.testSet * 60 / 100) * parseInt(this.veryhard.value) /
        this.getElementByDifficultyName('Very Hard').time);
    }
    else {
      this.veryhardPercentage = 0;
    }
    var numberOfQuestion = this.easyPercentage + this.mediumPercentage + this.hardPercentage + this.veryhardPercentage;
    this.percentageOfNo = (numberOfQuestion * this.noOfProgramQues.value) / 100;
  }

  onChangeTestType(event) {
    this.easy.setValue(0);
    this.medium.setValue(0);
    this.hard.setValue(0);
    this.veryhard.setValue(0);
    this.testTypeSelected = event.value;
    console.log("testTypeSelected", this.testTypeSelected);
    this.autoFillQuestionDifficulty(this.testTypeSelected);
  }

  timeSet(event) {
    console.log('event', event.value);
    this.testSet = event.value.testTime;
    // localStorage.setItem('testSetInTestFormat', this.testSet);
    // console.log('testSetInLocalStorage',localStorage.getItem('testSetInTestFormat'));
    console.log('testSet -->', this.testSet);
    this.autoFillQuestionDifficulty(this.testTypeSelected);
  }
}
